<template>
  <div id="custom-online">
    <Breadcrumb></Breadcrumb>
    <div class="form-body">
      <el-form label-width="95px" ref="form" :model="queryParams">
        <el-row v-if="user.userType == '01'" :gutter="20">
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-form-item label="设计账号：" class="item">
                <div
                  style="
                    max-height: 200px;
                    overflow-y: auto;
                    float: left;
                    width: calc(100% - 59px);
                  "
                >
                  <el-input
                    v-if="isExpandUser"
                    style="width: 139px; margin: 0 29px 0 0"
                    v-model="nickName"
                    size="small"
                    placeholder="操作账号"
                  ></el-input>
                  <el-checkbox @change="handleChangeUser" v-model="isCheckUser"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    filterable
                    v-model="queryParams.operNos"
                    placeholder="请选择姓名"
                    class="input"
                    size="small"
                    clearable
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(item, index) in userList"
                      :key="index"
                      :label="item.userName"
                      v-show="
                        (isExpandUser || index < 10) &&
                          item.nickName &&
                          item.nickName.indexOf(nickName) > -1
                      "
                    >
                      {{ item.nickName }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div
                  v-if="userList.length > 10"
                  @click="isExpandUser = !isExpandUser"
                  style="
                    margin: 0 0 0 16px;
                    cursor: pointer;
                    color: #4934b2;
                    float: left;
                  "
                >
                  {{ isExpandUser ? "－收起" : "＋展开" }}
                </div>
              </el-form-item>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col v-if="user.userType == '00'" :span="8">
            <el-form-item label="商家账号：" prop="createTime">
              <template>
                <el-select
                  clearable
                  size="small"
                  v-model="queryParams.pOperNo"
                  filterable
                   remote
                  :remote-method="getAccountList"
                >
                  <template v-for="(value, key) in accountList">
                    <el-option
                      :key="value.userName"
                      :label="
                        `${value.userName}${
                          value.nickName ? '(' + value.nickName + ')  ' : ''
                        }`
                      "
                      :value="value.userName"
                    ></el-option>
                  </template>
                </el-select>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="groupType"
              label="合成类型："
              class="hide_input"
            >
              <el-select
                clearable
                v-model="queryParams.groupType"
                placeholder="请选择合成类型"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="(value, index) in groupTypeArray"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              prop="remitFlag"
              label="是否汇出："
              class="hide_input"
            >
              <el-select
                clearable
                v-model="queryParams.remitFlag"
                placeholder="请选择"
                size="small"
                style="width: 100%"
              >
                <el-option label="是" value="1"> </el-option>
                <el-option label="否" value="0"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="user.userType == '00'" :span="8">
            <el-form-item label="设计人员：" prop="operNo">
              <el-select
                clearable
                size="small"
                v-model="queryParams.operNo"
                filterable
              >
                <template v-for="(value, key) in accountListAll">
                  <el-option
                    :key="value.userName"
                    :label="
                      `${value.userName}${
                        value.nickName ? '(' + value.nickName + ')  ' : ''
                      }`
                    "
                    :value="value.userName"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="成品编号：" prop="designId">
              <el-input
                size="small"
                v-model="queryParams.designId"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="主题名称：" prop="designProName">
              <el-input
                size="small"
                v-model="queryParams.designProName"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="定制名称：" prop="proName">
              <el-input
                size="small"
                v-model="queryParams.proName"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="产品编号：" prop="pId">
              <el-input
                size="small"
                v-model="queryParams.pId"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设计时间：" prop="createTime">
              <template>
                <el-date-picker
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  v-model="queryParams.timeRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="汇出SKU：" prop="itemSku">
              <el-input
                size="small"
                v-model="queryParams.itemSku"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属国家：" prop="state">
              <el-select
                multiple
                clearable
                v-model="queryParams.state"
                placeholder="请选择"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="(value, index) in dictData['country_site']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col v-if="user.userType == '00'" :span="8">
            <el-form-item label="是否删除：" prop="picName">
              <el-select size="small" clearable v-model="queryParams.delFlag">
                <el-option :label="`正常`" :value="`1`"></el-option>
                <el-option :label="`删除`" :value="`0`"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="user.userType == '00'" :span="8">
            <el-form-item label="优选情况：" prop="picName">
              <el-select size="small" clearable v-model="queryParams.isYx">
                <el-option :label="`已加入优选`" :value="`1`"></el-option>
                <el-option :label="`未加入优选`" :value="`0`"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="user.userType != '00' ? 24 : 8">
            <el-form-item style="text-align: right">
              <el-button size="small" type="primary" @click="getList"
                >搜索</el-button
              >
              <el-button size="small" @click="resetForm">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-body">
      <el-row class="table-menu">
        <el-col v-if="user.userType != '00'" :span="12">
          <el-dropdown
            placement="top"
            style="margin: 0 17px 0 0"
            @command="handleCommandExport"
          >
            <el-button size="small" type="primary">
              汇出<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="lazada">Lazada汇出</el-dropdown-item>
              <el-dropdown-item command="shopee">Shopee汇出</el-dropdown-item>
              <el-dropdown-item v-if="false" command="tiktok"
                >TikTok汇出</el-dropdown-item
              >
              <el-dropdown-item command="common">通用模板汇出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown
            placement="top"
            style="margin: 0 17px 0 0"
            @command="handleCommandUpload"
          >
            <el-button size="small" type="primary">
              一键上传<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="lazadaUpload"
                >Lazada上传</el-dropdown-item
              >
              <el-dropdown-item command="shopeeUpload"
                >Shopee上传</el-dropdown-item
              >
              <el-dropdown-item command="tiktokUpload"
                >TikTok上传</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>

          <el-button
            style="margin: 0 17px 0 0"
            @click="handleGroup"
            size="small"
            type="primary"
            >设置组合商品</el-button
          >
          <el-button
            v-if="showPushDesignButton"
            style="margin: 0 17px 0 0"
            @click="handleSendData"
            size="small"
            type="success"
            >数据推送</el-button
          >
          <el-button
            style="margin: 0 17px 0 0"
            type="danger"
            size="small"
            @click="handleDelItem"
            >批量删除</el-button
          >
          <el-button @click="handleJumpToBin" type="text"
            >回收站 <i class="el-icon-delete"></i
          ></el-button>
        </el-col>
        <el-col v-else>
          <el-button
            style="margin: 0 17px 0 0"
            @click="handleChangeProductType"
            size="small"
            type="primary"
            >批量转优选</el-button
          >
          <el-button type="primary" size="small" @click="handleClearCache"
            >刷新缓存</el-button
          >
        </el-col>
        <el-col
          :span="user.userType != '00' ? 12 : 24"
          style="text-align: right; height: 36px; line-height: 36px"
        >
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
            :autoScroll="false"
          />
        </el-col>
      </el-row>
      <div>
        <el-row style="display: flex; flex-wrap: wrap; background-color: white">
          <el-col
            :span="12"
            style="
              display: flex;
              padding-left: 20px;
              color: #333333;
              font-size: 14px;
              align-items: center;
            "
          >
            <div v-if="rowSelectNum > 0">已选中{{ rowSelectNum }}条数据</div>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>
        <el-table
          ref="table"
          :data="tableData"
          class="clain-tab"
          border
          :cell-class-name="cellcb"
          @selection-change="tableSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            label="成品编号"
            width="190px"
            align="center"
            prop="designId"
          >
            <template slot-scope="scope">
              <span
                @click="handleJumpDesign(scope.row)"
                class="el-button--text"
                style="cursor: pointer"
                >{{ scope.row.designId }}</span
              >
              <i
                title="复制"
                class="el-icon-document-copy"
                style="cursor: pointer;margin: 0 0 0 4px;"
                @click="copyText(scope.row.designId)"
              ></i>
              <br />
              {{ dictMap["country_site"][scope.row.state] }} / 
              {{ claLabel(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column label="合成类型" align="center" prop="designId">
            <template slot-scope="scope">
              <span>{{
                scope.row.groupType == "01" ? "多素材组合" : "单素材组合"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column width="177px" align="center" label="设计图片">
            <template slot-scope="scope">
              <el-popover
                placement="right"
                trigger="hover"
                :close-delay="closeDelay"
              >
                <div
                  slot="reference"
                  style="display: float; float: left; margin: 0 8px 0 26px;position: relative;"
                >
                  <span style="position:absolute;background-color: #aaaaaa;padding: 0 4px;color: #ffffff;">{{ scope.row.ifNew === '01' ? '新' : '旧' }}</span>
                  <img
                    class="img-small"
                    :src="
                      `${
                        scope.row.coverPicUrl
                          ? scope.row.coverPicUrl
                          : scope.row.picUrl
                      }?x-oss-process=image/resize,m_fill,h_200,w_200`
                    "
                  />
                  <div class="site">站点 {{ scope.row.state }}</div>
                </div>
                <div style="overflow:hidden;">
                  <a
                    style="cursor: pointer;float:left;"
                    @click="handlePreview(scope.row)"
                    >预览效果图</a
                  >
                  <a
                    style="cursor: pointer;float:right;"
                    @click="handleShowSku(scope.row)"
                    >查看SKU</a
                  >
                </div>
                <div>
                  <img
                    class="img-big"
                    :src="
                      `${
                        scope.row.coverPicUrl
                          ? scope.row.coverPicUrl
                          : scope.row.picUrl
                      }?x-oss-process=image/resize,m_fill,h_300,w_300`
                    "
                    style="width: 300px; height: 300px"
                  />
                </div>
                <div style="overflow:hidden;">
                  <a
                    style="cursor: pointer;float:left;"
                    @click="handleDownloadPic(scope.row)"
                    >下载效果图</a
                  >
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column width="169" label="主题名称" align="center">
            <template slot="header">
              主题名称<br />(<span
                @click="handleShowCellDialog('designProName', '主题名称')"
                class="primary-color pointer"
                >一键设置</span
              >)
            </template>
            <template slot-scope="scope">
              <div style="text-align:left;" :title="scope.row.designProName">
                {{ scope.row.designProName }}
                <div
                  style="display:inline-block;"
                  v-if="scope.row.designEngProName"
                >
                  (字符数<span style="color:#4934b2;font-weight:bold;">{{
                    scope.row.designProName.length
                  }}</span
                  >)
                </div>
                <i
                  v-if="user.userType != '00'"
                  @click="handleShowEdit(scope.row)"
                  style="color: #4934b2; cursor: pointer"
                  class="el-icon-edit"
                ></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="价格" align="center">
            <template slot-scope="scope">
              <span>￥{{ scope.row.price }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="生产时长" align="center" prop="cycle">
          <template slot-scope="scope">
            <span>{{ scope.row.cycle }}天</span>
          </template>
        </el-table-column> -->
          <el-table-column label="定制名称" align="center" prop="proName">
            <template slot-scope="scope">
              <span
                @click="handleJumpProduct(scope.row)"
                class="el-button--text"
                style="cursor: pointer"
                >{{ scope.row.proName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="汇出店铺" align="center" prop="shopList">
            <template slot-scope="scope">
              <div
                :title="record"
                class="text-ellipsis"
                v-for="(record, index) in scope.row.shopList"
                :key="index"
              >
                {{ record }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-if="user.userType == '00'"
            label="商家账号"
            align="center"
            prop="pOperNo"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.pOperNo }}</span>
            </template>
          </el-table-column>
          <el-table-column label="设计人员" align="center" prop="nickName">
            <template slot-scope="scope">
              <span>{{
                scope.row.nickName ? scope.row.nickName : scope.row.operNo
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="设计时间"
            align="center"
            prop="createTime"
            width="179"
          ></el-table-column>
          <el-table-column
            v-if="user.userType == '00'"
            label="状态"
            align="center"
            prop="nickName"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.delFlag == "1" ? "正常" : "删除" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            prop="hand"
            width="105"
            header-align="center"
            align="center"
            v-if="user.userType != '00'"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.editFlag == '1' && scope.row.groupType == '01'"
                type="text"
                size="small"
                @click="handleNotGroup(scope.row)"
                >取消组合</el-button
              ><br />
              <el-button
                v-if="scope.row.editFlag == '1'"
                type="text"
                size="small"
                @click="handleShowEdit(scope.row)"
                >编辑</el-button
              ><br />
              <a
                v-if="scope.row.ifNew === '01'"
                target="_blank"
                :href="`${getDesignUrl}?designId=${scope.row.designId}`"
                >重新设计</a
              >
              <a
                v-else
                target="_blank"
                :href="`/design/online/tool?designId=${scope.row.designId}`"
                >重新设计</a
              ><br />
              <el-button
                type="text"
                size="small"
                @click="handleShowCart(scope.row)"
                >加入购物车</el-button
              ><br />
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            prop="hand"
            width="105"
            header-align="center"
            align="center"
            v-if="user.userType == '00'"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.isYx == '1'">已加入优选</span>
                <el-button
                  v-else
                  type="text"
                  size="small"
                  @click="handleAddProduct(scope.row)"
                  >转优选</el-button
                >
              </div>
              <div>
                <el-button
                  type="text"
                  size="mini"
                  @click="handleClear(scope.row)"
                  >刷新缓存</el-button
                ><br />
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
          :autoScroll="false"
        />
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="加入购物车"
      width="800px"
      class="common-limit"
      :destroy-on-close="true"
      :visible.sync="cartDialogVisible"
    >
      <div style="height: 460px; overflow-y: auto; overflow-x: hidden">
        <div v-for="(record, index) in cartArray" :key="index">
          <div class="product-title">
            {{ record.proName }}
          </div>
          <el-form ref="form" label-width="80px">
            <el-row :gutter="24">
              <el-col :span="9">
                <div
                  style="
                    border: 1px solid #e3e3e3;
                    width: 180px;
                    height: 180px;
                    padding: 5px;
                  "
                >
                  <img
                    :src="
                      `${record.currentSku.mainPic.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                    "
                    width="180"
                    height="180"
                    alt=""
                  />
                </div>
              </el-col>
              <el-col :span="15">
                <div class="sku-attr">
                  <div class="sku-name">颜色</div>
                  <div class="sku-detail">
                    <a
                      :style="{ background: dictMap['color'][color] }"
                      :class="{
                        'is-select': record.currentAttr.color === color,
                      }"
                      @click="handleSelectColor(record, color)"
                      class="sku-color"
                      v-for="(color, index) in getColorList(record)"
                      :key="index"
                      :title="color"
                    ></a>
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-name">尺码</div>
                  <div class="sku-detail">
                    <a
                      :class="{ 'is-select': record.currentAttr.size === size }"
                      @click="handleSelectSize(record, size)"
                      class="sku-size"
                      v-for="(size, index) in getSizeList(record)"
                      :key="index"
                      >{{ size }}</a
                    >
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-name">数量</div>
                  <div class="sku-detail" style="margin: 0">
                    <el-input-number
                      style="width: 90px"
                      v-model="record.productNum"
                      size="small"
                      controls-position="right"
                      :precision="0"
                      :min="1"
                      :step="1"
                      :max="9999"
                    ></el-input-number>
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-name">单价</div>
                  <div class="sku-detail primary-color" style="margin: 0">
                    <div style="float: left">
                      ￥<span class="sku-price">{{
                        record.currentSku.price
                      }}</span>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="handleJump('/order/myOrder/shopCart')" size="small"
          >查看购物车</el-button
        >

        <el-button @click="handleAddCart()" size="small" type="primary"
          >加入购物车</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="编辑"
      width="800px"
      class="common-limit"
      :destroy-on-close="true"
      :visible.sync="editVisible"
    >
      <div style="height: 460px; overflow-y: auto; overflow-x: hidden">
        <div v-for="(record, index) in cartArray" :key="index">
          <div class="product-title">
            {{ record.proName }}
            <a
              target="_blank"
              :href="`${editDesignItem.ifNew === '01' ? getDesignUrl : '/design/online/tool'}?designId=${record.designId}`"
              >重新设计</a
            >
          </div>
          <el-form ref="form" label-width="80px">
            <el-row :gutter="24">
              <el-col :span="9">
                <div
                  style="
                    border: 1px solid #e3e3e3;
                    width: 180px;
                    height: 180px;
                    padding: 5px;
                  "
                >
                  <img
                    :src="
                      `${record.currentSku.mainPic.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                    "
                    width="180"
                    height="180"
                    alt=""
                  />
                </div>
                <div>
                  <div style="margin-top: 0" class="sku-attr">
                    <div class="sku-name">颜色</div>
                    <div class="sku-detail">
                      <a
                        :style="{ background: dictMap['color'][color] }"
                        :class="{
                          'is-select': record.currentAttr.color === color,
                        }"
                        @click="handleSelectColor(record, color)"
                        class="sku-color"
                        v-for="(color, index) in record.attribute['颜色']"
                        :key="index"
                        :title="color"
                      ></a>
                    </div>
                  </div>
                  <div style="margin-top: 0" class="sku-attr">
                    <div class="sku-name">尺码</div>
                    <div class="sku-detail">
                      <a
                        class="sku-size"
                        v-for="(size, index) in getSizeList(record)"
                        :key="index"
                        >{{ size }}</a
                      >
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="15">
                <div class="sku-attr">
                  <div class="sku-name">成品编号：</div>
                  <div class="sku-detail" style="margin: 0; width: 330px">
                    {{ record.designId }}
                    <el-button
                      style="margin: 0 0 0 16px"
                      @click="handleSetParent(record)"
                      v-if="record.designId !== record.groupDesignId"
                      size="small"
                      type="primary"
                      >设为母体</el-button
                    ><span style="color: #4934b2; margin: 0 0 0 16px" v-else
                      >已设置为母体</span
                    >
                  </div>
                </div>
                <div v-show="false" class="sku-attr">
                  <div class="sku-name">设计后中文名称：</div>
                  <div class="sku-detail" style="margin: 0; width: 330px">
                    <el-input v-model="record.proName" size="small"></el-input>
                  </div>
                </div>
                <div class="sku-attr">
                  <div class="sku-name">主题名称：</div>
                  <div class="sku-detail" style="margin: 0; width: 330px">
                    <el-input v-model="record.proName" size="small"></el-input>
                  </div>
                </div>
                <div class="sku-attr">
                  <div
                    class="sku-detail"
                    style="margin: 0; width: 330px; margin: 0 0 0 109px"
                  >
                    <el-button
                      @click="handleModifyDesign(record)"
                      size="small"
                      type="primary"
                      >保存</el-button
                    >
                    <el-button
                      v-if="false"
                      @click="handleEditDesign(record)"
                      size="small"
                      type="primary"
                      >修改设计</el-button
                    >
                    <el-button
                      v-if="false"
                      @click="handleReDesign(record)"
                      size="small"
                      type="primary"
                      >重新设计</el-button
                    >
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="editVisible = false" size="small" type="primary"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="批量转优选"
      width="800px"
      class="common-limit"
      :destroy-on-close="true"
      :visible.sync="showBatch"
    >
      <div>
        <el-form :label-width="90" :model="formBatch">
          <el-form-item label="产品分类：" prop="typeId">
            <TreeSelect
              :props="treeSelectProps"
              :options="productTypeList"
              v-model="formBatch.typeId"
              ref="childSelTree"
              @getValue="getTreeNodeId"
            ></TreeSelect>
          </el-form-item>
          <el-form-item
            label="标签属性："
            style="margin-top: 20px"
            prop="labelAttr"
          >
            <el-checkbox-group
              style="overflow: hidden"
              v-model="formBatch.labelAttr"
              size="small"
            >
              <div
                style="display: inline-block; margin: 0 16px 0 0; float: left"
                :key="count"
                v-for="(item, count) in labelAttrList"
                :style="{
                  clear:
                    item.value.length == 2 && count > 1 ? 'both' : 'inherit',
                }"
              >
                <el-checkbox
                  v-if="item.value.length == 4"
                  :label="item.value"
                  >{{ item.label }}</el-checkbox
                >
                <span style="font-size: 14px; color: #606266" v-else>{{
                  item.label
                }}</span>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="showBatch = false" size="small" type="primary"
          >关闭</el-button
        >
        <el-button @click="handleBatch" size="small" type="primary"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="详情"
      width="800px"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :visible.sync="detailVisible"
    >
      <div>
        <el-table
          id="outTable"
          ref="multipleTable"
          :data="detailData"
          tooltip-effect="dark"
          style="width: 100%"
          lazy
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        >
          <el-table-column
            prop="groupDesignId"
            label="合成编号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="designId"
            label="成品编号"
            align="center"
          ></el-table-column>
          <el-table-column width="177px" align="center" label="设计图片">
            <template slot-scope="scope">
              <el-popover
                placement="right"
                trigger="hover"
                :close-delay="closeDelay"
              >
                <div
                  slot="reference"
                  style="display: float; float: left; margin: 0 8px 0 26px;"
                >
                  <img
                    class="img-small"
                    :src="
                      `${scope.row.picUrl}?x-oss-process=image/resize,m_fill,h_200,w_200`
                    "
                  />
                </div>
                <img
                  class="img-big"
                  :src="
                    `${scope.row.picUrl}?x-oss-process=image/resize,m_fill,h_300,w_300`
                  "
                  style="width: 300px; height: 300px"
                />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="templateState" label="主题名称" align="center">
            <template slot-scope="scope">
              <a
                @click.prevent="handleJumpDetailDesign(scope.row.designId)"
                class="templateName"
                >{{ scope.row.designProName }}</a
              >
            </template>
          </el-table-column>
          <el-table-column prop="itemSku" label="定制名称" align="center">
            <template slot-scope="scope">
              <a
                @click.prevent="handleJumpDetailProduct(scope.row.pId)"
                class="templateName"
                >{{ scope.row.proName }}</a
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button size="small" type="primary" @click="detailVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="SKU详情"
      width="800px"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :visible.sync="skuVisible"
    >
      <div style="max-height: 500px;overflow-y: auto;" v-if="showRemitSku">
        <el-table
          id="outTable"
          ref="multipleTable"
          border=""
          :data="detailSkuRemit"
          :span-method="objectSpanMethodRemit"
          tooltip-effect="dark"
          style="width: 100%"
          height="400"
          lazy
        >
          <el-table-column
            prop="remitTime"
            label="汇出时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="designProName"
            label="主题名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="parentSku"
            label="父SKU"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="itemSku"
            label="汇出SKU"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="color"
            label="颜色"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="size"
            label="尺码"
            align="center"
          ></el-table-column>
        </el-table>
      </div>

      <div style="max-height: 500px;overflow-y: auto;" v-else>
        <el-table
          id="outTable"
          ref="multipleTable"
          :data="detailSku"
          :span-method="objectSpanMethod"
          tooltip-effect="dark"
          style="width: 100%"
          height="400"
          lazy
        >
          <el-table-column
            prop="designProName"
            label="主题名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="color"
            label="颜色"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="size"
            label="尺码"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button size="small" type="primary" @click="skuVisible = false"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :title="`修改${cellTitle}`"
      :visible.sync="showCellDialog"
      width="580px"
      @close="handleCloseCellDialog"
    >
      <el-row style="margin-top: 15px; margin-left: 15px">
        <span style="display: inline-block;float:left;margin: 4px 0 0 0;"
          >{{ cellTitle }}：</span
        >
        <el-input
          v-model.trim="cellValue"
          :title="`请输入${cellTitle}`"
          size="mini"
          style="width: 450px;float:left;"
        ></el-input>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseCellDialog" size="small">取 消</el-button>
        <el-button type="primary" @click="handleUpdateCell" size="small"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <vxe-modal
      title="选择待发布店铺"
      v-model="shopSelectDialog"
      width="600"
      height="300"
      showFooter
    >
      <template>
        <div>
          <el-checkbox-group v-model="checkedShops">
            <el-checkbox
              v-for="item in shopList"
              :label="item.shopId"
              :key="item.shopId"
              >{{ item.shopName }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="shopSelectDialog = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="submitSelect"
            >确 定</el-button
          >
        </span>
      </template>
    </vxe-modal>

    <el-dialog
      :close-on-click-modal="false"
      title="效果图预览"
      :visible.sync="showPreview"
      width="800px"
    >
      <div class="preview-area">
        <div class="carousel">
          <el-carousel
            ref="carouselPreview"
            style="height: 500px; overflow: hidden"
            :autoplay="false"
            :interval="5000"
            arrow="always"
          >
            <el-carousel-item
              v-for="(productImage, index) in productImageList"
              :key="index"
            >
              <img :src="productImage.picUrl" />
            </el-carousel-item>
          </el-carousel>
          <div class="color-picker">
            <ul class="color-picker-list">
              <li
                @click="handlePickColor(record)"
                v-for="record of getColorList(detail)"
                :key="record"
                :class="{ cur: currentColor === record }"
              >
                <a :style="{ backgroundColor: dictMap['color'][record] }"></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="preview-list">
          <div
            v-for="(productImage, index) in productImageList"
            :key="index"
            class="preview-list-item"
            :class="{ 'is-active': activeCarousel === index }"
            @click="handleClickPreviewImage(index)"
          >
            <img :src="productImage.picUrl" />
            <div class="preview-text">效果图{{ index + 1 }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb'
import {listDesign ,delDesign, updateDesign, getCartInfo, getCartMatchInfo, getDesign, addGroup , cancelGroup, listGroup, setGroupMain, cleaCache, pushDesign, getUserInfo} from '@/api/customProduct/design'
import {mapGetters} from 'vuex'
import {addCart, addOrEdit} from '@/api/order/cart'
import {addBatch} from '@/api/customProduct/product'
import {getDesignSku} from '@/api/customProduct/designSku'
import {getAllShop} from "@/api/plat/platType";
import {moveToRelease} from "@/api/customProduct/custom";
import {addToShoppingCart} from'@/api/customProduct/custom'
import CKEditor4 from '@/components/common/CKEditor'
import { listSubAccount } from "@/api/system/user"
import { listUser } from "@/api/business/merchantManage"
import TreeSelect from '@/components/common/treeSelect';
import { getProductTypeTree } from "@/api/product/type";
import {getSkuList , listRemitSkuByDesignId} from '@/api/template/template.js'

export default {
    name: "product",
    components:{Breadcrumb, CKEditor4, TreeSelect},
    data(){
        return{
            // 遮罩层
            loading: true,
            closeDelay:0,
            total:0,
            queryParams:{
                pageNum: 1,
                pageSize: 100,
                timeRange: null,
                designId: null,
                designProName: null,
                proName: null,
                productType: null,
                operNos: [],
                remitFlag: null,
                beginTime: null,
                endTime: null,
                groupType: '',
                delFlag: undefined,
                pOperNo: '',
                pId: '',
                isYx: '',
                itemSku: '',
                state: []
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            groupTypeArray: [
              {label : '多素材组合' ,value: '01'},
               {label : '单元素组合' ,value: '02'},
                {label : '简单商品' ,value: '03'},

            ],
            attribute: {},
            currentAttr: {
              color: "",
              size: "",
            },
            showCellDialog: false,
            cellTitle: "",
            cellName: "",
            cellValue: "",
            cellType: "",
            skuVisible:false,
            showRemitSku: false,
            currentSku: {},
            mainPic: '',
            productNum: 1,
            tableData:[],
            detailData: [],
            cartArray: [],
            claimCollIds:[],////选中 的产品id
            claimSkuNum: [],
            claimProduct: [],
            cartDialogVisible: false,
            cartData: [],
            commodity: {},
            totalCount: 0,
            totalNum: 0.00,
            totalPrice: 0.00,
            detailSku: [],
            pIds: [],
            detailSkuRemit: [],
            /*临时字段区--用于记录*/
            lastId: "",
            platList:[],
            shopSelectDialog:false,
            shopList:[],
            checkAll: false,
            checkedShops: [],
            checkPlat:undefined,
            isIndeterminate: true,
            currentRow:null,
            /* 新增的修改需求用到的字段 */
            colors: [],
            sizes: [],
            form: {},
            singlePrice: '',
            editDesignItem: {},
            editVisible: false,
            detailVisible: false,
            detailInfo: {},
            editor: null,
            editorConfig:{
              allowedContent: true,//设置为true，以防止CKEditor 4删除不允许的元素
              extraPlugins:['uploadImg'],
              height:'300px',
              toolbar : [
                  [ 'Maximize'],
                  [ 'Bold', 'Italic', 'Underline', 'Strike'],
                  [ 'TextColor', 'BGColor' ],
                  [  'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock','-','NumberedList', 'BulletedList', '-', 'Outdent', 'Indent',  '-','Subscript', 'Superscript'],
                  [ 'HorizontalRule','RemoveFormat'],
                  [ 'Undo', 'Redo' ],
                  '/',
                  [ 'Styles', 'Format', 'Font', 'FontSize' ],
                  [ 'Table'],
                  [ 'uploadImg']
              ],
              language: 'zh-cn',
              wordcount:{
                  showCharCount: true,
              }
            },
            scrollMenu: null,
            objectHeight: null,
            showPreview: false,
            previewImages: [],
            productImageList: [],
            detail: {},
            currentColor: "",
            activeCarousel: 0,
            isExpandUser: false,
            nickName: "",
            isCheckUser: true,
            accountList: [],
            accountListAll: [],
            userList: [],
            showBatch: false,
              productTypeList: [],
        treeSelectProps: {
          value:'typeId',             // ID字段名
          label: 'typeName',         // 显示名称
          children: 'childrenTree'    // 子级字段名
        },
        formBatch: {
          typeId: '',
          labelAttr: [],
          designId: []
        },
        labelAttrList: [],
        designIdList: [],
        showPushDesignButton: false
        }
    },
    computed: {
        ...mapGetters(["dictData", "dictMap", 'nginx', 'user']),
        rowSelectNum(){
                return this.claimCollIds.length;
        },

        sizeList(detail) {
          return ()=>{
              let sizeList = []
              if (detail.skuList) {
                for (let record of detail.skuList) {
                  let color = record.properVal.split(":")[0]
                  let size = record.properVal.split(":")[1]
                  if (color == this.currentAttr.color) {
                    if (!sizeList.includes(size)) {
                      sizeList.push(size)
                    }
                  }
                }
              }
              return sizeList
            }
        },
        colorList(detail) {
          return ()=>{
            let colorList = []
            if (detail.skuList) {
              for (let record of detail.skuList) {
                let color = record.properVal.split(":")[0]
                if (!colorList.includes(color)) {
                  colorList.push(color)
                }
              }
            }
            return colorList
          }
        },
        routeName() {
          return this.$route.path
        },
        getDesignUrl() {
          return localStorage.getItem('isNewDesignFlag') === '2' ? '/design/online/designerOther' : '/design/online/designerNew'
        }
      },
    watch:{
        shopSelectDialog(val, oldVal){
            if(!val){
                this.checkedShops = [];
            }
        },
         routeName: {
      handler() {
           let curDate = new Date()
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

        this.queryParams.timeRange = [this.parseTime(preDate, "{y}-{m}-{d}") , this.parseTime(curDate,"{y}-{m}-{d}")]
          this.getList();
      },
      immediate: true
    },
    },
    async created() {
        this.getCache('1')
        let curDate = new Date()
        let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

        this.queryParams.timeRange = [this.parseTime(preDate, "{y}-{m}-{d}") , this.parseTime(curDate,"{y}-{m}-{d}")]
        this.initPlatData();
        this.getUserList()
        this.getAccountList()
        this.getAccountListAll()

        this.$nextTick(()=>{
           this.scrollMenu = document.querySelector('.table-menu')
           this.objectHeight = this.scrollMenu.offsetTop
           window.addEventListener('scroll', this.handleScroll)
        })
        let labelAttrList = []
        let LABEL_ATTR = this.dictData['LABEL_ATTR'] || []
        for(let record of LABEL_ATTR){
          if(record.value.length == 4){
            record.weight = Number(record.value)
          } if(record.value.length == 2){
            record.weight = Number(record.value) * 100
          }
        }
        labelAttrList = this._.sortBy(LABEL_ATTR, function(item){
          return Number(item.weight)
        })
        this.labelAttrList = labelAttrList

        //获取数据
        let userInfo = await getUserInfo(this.user.name)
        if(userInfo.data){
          this.showPushDesignButton = true
        }
    },
    destroyed(){
      window.removeEventListener('scroll', this.handleScroll)
    },
    methods:{
      claLabel(data){
        const v =  this.dictData['MANUFACTURER'].find((item)=>data.product.manufacturer==item.value)
        return v && v.label
      },
      getTreeNodeId(value){
        this.formBatch.typeId = value
      },
      async getAccountList(query) {
         if(!query){
        query = ""
      }
      let result = await listUser({
        pageNum: 1,
        pageSize: 10,
        userType: "01",
         userName: query
      })
      this.accountList = result.rows
      },
          async getProductTypeTree() {
        let result = await getProductTypeTree();
        this.productTypeList = result.data;
      },
      cellcb(table){
        if(table.row.isYx == '1' && table.columnIndex === 0 &&  this.user.userType == '00'){
          return "myCell"
        }
      },
      async getAccountListAll() {
      let result = await listUser({
        pageNum: 1,
        pageSize: 100000,
      })
      this.accountListAll = result.rows
      },
      handlePickColor(color) {
        this.currentColor = color
        this.setProductImageList()
      },
      setProductImageList() {
        let images = []
        for (let record of this.detail.skuList) {
          if (record.properVal.indexOf(this.currentColor) > -1) {
            images = record.picList
            break
          }
        }
        this.productImageList = images
      },
      handleScroll(){
        var menu = this.scrollMenu
        //获取页面的滚动距离
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop;
        //滚动到一定位置 div固定到顶部 js实现吸顶
        console.log(scrollHeight + ',' + this.objectHeight)
        if (this.objectHeight < scrollHeight) {
            menu.style.position = "fixed";
            menu.style.top = 0;
            menu.style.width = 'calc(100% - 312px)'
        } else {
            menu.style.position = "relative";
            menu.style.width = '100%'
        }
      },
       handleShowCellDialog(cellType, cellTitle) {
      this.cellValue = ""
      this.showCellDialog = true
      this.cellType = cellType
      this.cellTitle = cellTitle
    },
      handleCommandExport(command){
         if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        let platNo = ''
        let upload = '0'
        if(command == 'common'){
          platNo = '09'
        }
        if(command == 'lazada' || command == 'lazadaUpload'){
          platNo = '03'
        }
         if(command == 'shopee'){
          platNo = '05'
        }
          if(command == 'tiktok'){
          platNo = '10'
        }
        if(command == 'lazadaUpload'){
          upload = '1'
          command = 'lazada'
        }
        if(command == 'amazon'){
          this.$router.push(`/carry/proCustom/createTemplateData?designId=${this.claimCollIds.join(',')}&name=${this.claimProduct.join('，').replace(/&/g,' ')}`)
        }else{
        this.$router.push(`/carry/common/createTemplateData?designId=${this.claimCollIds.join(',')}&skuNum=${this.claimSkuNum.join(',')}&platName=${command}&platId=${command}&platNo=${platNo}&upload=${upload}&name=${this.claimProduct.join('，').replace(/&/g,' ').replace(/#/g,' ')}`)
        }
      },
      handleCommandUpload(command){
         if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        let platNo = ''
        let upload = '0'
         if(command == 'common'){
          platNo = '09'
        }
        if(command == 'lazada' || command == 'lazadaUpload'){
          platNo = '03'
        }
         if(command == 'shopee' || command == 'shopeeUpload'){
          platNo = '05'
        }
          if(command == 'tiktok' || command == 'tiktokUpload'){
          platNo = '10'
        }
        if(command == 'lazadaUpload'){
          upload = '1'
          command = 'lazada'
        }
         if(command == 'shopeeUpload'){
          upload = '1'
          command = 'shopee'
        }
         if(command == 'tiktokUpload'){
          upload = '1'
          command = 'tiktok'
        }
         if(command == 'amazon'){
          this.$router.push(`/carry/proCustom/createTemplateData?designId=${this.claimCollIds.join(',')}&name=${this.claimProduct.join('，').replace(/&/g,' ')}`)
        }else{
          this.$confirm('主题名称建议都修改为大于30个字符，以免影响产品上架', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.$router.push(`/carry/common/createTemplateData?designId=${this.claimCollIds.join(',')}&skuNum=${this.claimSkuNum.join(',')}&name=${this.claimProduct.join('，').replace(/&/g,' ').replace(/&/g,' ').replace(/#/g,' ')}&platName=${command}&platId=${command}&platNo=${platNo}&upload=${upload}`)
          }).catch(() => {
          });
        }
      },

      async handleGroup(){
        if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        this.$confirm('请确认是否组合商品', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let result = await addGroup({designId : this.claimCollIds.join(',') })
          this.msgSuccess('设置组合成功')
          this.getList()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      async handleSendData(){
        if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
        }
        this.$confirm('请确认是否推送数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let result = await pushDesign(this.claimCollIds.join(','))
          this.msgSuccess('推送成功')
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      async handleBatch(){
        let formBatch = this._.clone(this.formBatch)
        formBatch.designId = this.claimCollIds.join(',')
        formBatch.labelAttr = formBatch.labelAttr.join(',')
        try {
            let result = await addBatch(formBatch)
            this.showBatch = false
            this.getList()
            this.$message({
                type: 'success',
                message: '批量转优选成功'
            });
        } catch (error) {
          this.$message({
                  type: 'error',
                  message: '批量转优选错误'
              });
        }

      },
      handleModifyDesign(row){
        let params = {
          designId: row.designId,
          designProName: row.proName,
        }
        //验证不能包含特殊字符
        var regex = /^((?!\\|\/|:|\*|\?|<|>|\||'|%|@|#|&|\$|\^|&|\*|,|\.|_|。|，).){1,255}$/
        if(!regex.test(row.proName)){
          this.msgError('主题名称不允许带特殊字符，比如下划线、逗号等');
          return
        }

        updateDesign(params).then(re => {
            this.$message({
                type: 'success',
                message: '保存成功'
            });
            this.getList()
            this.editVisible = false;
          }).catch(err =>{
        });
      },
      async handleUpdateCell() {
       let proName = this.cellValue
      for (let row of this.tableData) {
      let params = {
          designId: row.designId,
          designProName: proName,
        }
        //验证不能包含特殊字符
        var regex = /^((?!\\|\/|:|\*|\?|<|>|\||'|%|@|#|&|\$|\^|&|\*|,|\.|_|。|，).){1,255}$/
        if(!regex.test(proName)){
          this.msgError('主题名称不允许带特殊字符，比如下划线、逗号等');
          return
        }

        await updateDesign(params)
        }
         this.$message({
                type: 'success',
                message: '保存成功'
            });
             this.getList()
          this.showCellDialog = false
      },
      handleJumpProduct(row){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { pId: row.pId }} );
        window.open(routeUrl.href, '_blank');
      },
      async  handleJumpDesign(row){
        if(row.groupType == '01'){
          let result = await listGroup({groupDesignId: row.groupDesignId})
          this.detailData = result.rows
          this.detailVisible = true
        }else{

          let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { designId: row.designId }} );
          window.open(routeUrl.href, '_blank');
        }
      },
      handleJumpDetailDesign(designId){
        window.open(routeUrl.href, '_blank');
      },
      handleJumpDetailProduct(pId){
        let routeUrl = this.$router.resolve({ path: "/select/custom/product", query: { pId: pId }} );
        window.open(routeUrl.href, '_blank');
      },
      handleJump(path){
        this.$router.push({path: path})
      },
      handleChangeProductType(){
        if(this.claimCollIds.length == 0)
        {
          this.msgError('请选择成品')
          return
        }
        this.formBatch =  {
          typeId: '',
          labelAttr: [],
          designId: []
        }
        if(this.productTypeList.length == 0){
          this.getProductTypeTree()
        }
        this.showBatch = true
      },
      copyText(text) {
        let target = document.createElement("input") //创建input节点
        target.value = text // 给input的value赋值
        document.body.appendChild(target)
        target.value = text // 修改文本框的内容
        target.select() // 选中文本
        document.execCommand("copy") // 执行浏览器复制命令
        this.msgSuccess("复制成功")
        document.body.removeChild(target)
      },
      getUserList() {
        listSubAccount({}).then((res) => {
          res.rows.unshift({
            userName: this.user.name,
            nickName: this.user.nickName ? this.user.nickName : this.user.name,
          })
          this.userList = res.rows
        })
      },
      async handleAddCart() {
        let cartArray = this._.clone(this.cartArray)
        let form = []
        for(let record of cartArray){
          if(record.select){
            form.push({
              pId: record.pId,
              designId: record.designId,
              properName: record.currentSku.properName,
              productNum: record.productNum,
              properVal: record.currentSku.properVal,
              skuId:  record.currentSku.skuId,
              productType: record.productType
            })
          }
        }
        if(form.length == 0){
          this.msgError('商品至少需要选择一个')
          return
        }
        try {
          await addCart(form)
          this.$store.dispatch("GetIndexStat")
          this.msgSuccess("加入购物车成功")
        } catch (error) {}
      },
      // table数据
      getList(){
        this.setCache('1')
            this.startLoading()
            let params = this._.clone(this.queryParams)
            if(params.timeRange){
              params.beginTime = params.timeRange[0]
              params.endTime = params.timeRange[1]
            }
            params.state = params.state.join(',')
            delete params["timeRange"]
            params.operNos = params.operNos.join(',')
            if(this.user.userType !== '00'){
              params.delFlag = '1'
            }
            if(this.routeName.indexOf('/select/selection/design') > -1 || this.routeName.indexOf('/carry/proCustom/design') > -1){
              params.sDesignId = '01'
            }else {
              params.sDesignId = '02'
            }



            listDesign(params).then((re) => {
                this.tableData = re.rows;
                this.total = re.total;
                this.endLoading();
            }).catch(err =>{ this.endLoading();});
      },
      getColorList(detail){
        let colorList = []
        if (detail.skuList) {
          for (let record of detail.skuList) {
            let color = record.properVal.split(":")[0]
            if (!colorList.includes(color)) {
              colorList.push(color)
            }
          }
        }
        return colorList
      },
      getSizeList(detail){
        let sizeList = []
        if (detail.skuList) {
          for (let record of detail.skuList) {
            let size = record.properVal.split(":")[1]
            if (!sizeList.includes(size)) {
              sizeList.push(size)
            }
          }
        }
        return sizeList
      },
      async  handleNotGroup(row){
        try {
            this.$confirm('请确认是否取消组合商品', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(async () => {
              let result = await cancelGroup({groupDesignId: row.designId})
              this.msgSuccess('取消组合成功')
              this.getList()
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });

        } catch (error) {

        }
        },
        resetForm(){
          this.queryParams.productType = null
          this.queryParams.remitFlag = null
          this.queryParams.timeRange = []
          this.$refs['form'].resetFields();
        },
        tableSelectionChange(val){
            this.claimCollIds = [];
            this.claimProduct = [];
            this.claimSkuNum = [];
            val.forEach(r =>{
                this.claimCollIds.push(r.designId)
                this.claimProduct.push(r.designProName)
                this.claimSkuNum.push(r.skuList.length)
            });

        },

        handleClickPreviewImage(index) {
          this.$refs["carouselPreview"].setActiveItem(index)
          this.activeCarousel = index
        },

        /*跳到我的详情*/
        showDetail(row){
            this.$router.push({path:'/carry/proCustom/particulars', query: row})
        },
        handleAddProduct(row){
          let routeUrl = this.$router.resolve({
            path: "/product_mng/manage/createGoods",
            query:  {
            pId: row.pId,
            designId: row.designId
          }})
          window.open(routeUrl.href, "_blank")
        },

        /*点击加入购物车*/
        async handleShowCart(row) {
          try {
            let cartData = await getCartMatchInfo(row.designId)
            cartData.data.map(record=>{
              record.productNum = 1
              record.currentSku = record.skuList[0]
              record.attribute = JSON.parse(record.attribute)

              record.currentAttr = {color : '', size: ''}
              let colorList = record.attribute['颜色']
              if(colorList && colorList.length == 1){
                record.currentAttr.color = colorList[0]
              }
              // record.currentAttr.size = properVal[1]
              // record.currentAttr
            })
            this.cartArray = cartData.data

            // this.currentSku = cartData.data.skuList[0]
            // this.mainPic = this.currentSku.picList[0].picUrl
            this.cartDialogVisible = true
          } catch (error) {
          }
        },
         /*点击加入购物车*/
        async handlePreview(row) {
          try {
            this.startLoading()
            let result = await getDesign(row.designId)
            this.detail = result.data
            this.currentColor = this.detail.skuList[0].properVal.split(':')[0]
            this.handlePickColor(this.currentColor)
            this.showPreview = true
            this.activeCarousel = 0
            this.endLoading()
          } catch (error) {
            this.endLoading()
          }
        },
        async handleClearCache(){
         try {
           if(this.claimCollIds.length == 0){
             this.msgError('请选择设计');
             return;
           }
          await cleaCache(this.claimCollIds.join(','))
          this.msgSuccess(`刷新成功`)
          this.getData()
        } catch (error) {
        }
        },
        async handleClear(row){
            try {
            await cleaCache(row.designId)
            this.msgSuccess(`刷新成功`)
            this.getData()
          } catch (error) {
          }
        },
         /*点击加入购物车*/
        async handleShowSku(row) {
          try {
            this.startLoading()
            if(row.shopList.length > 0){
              let result = await listRemitSkuByDesignId({designId: row.designId})
              let rows = []
              for(let record of result.rows){
                for(let i =0; i< record.skuList.length; i++){
                  let data = {
                    designProName: record.designProName,
                    color: record.skuList[i].color,
                    size: record.skuList[i].size,
                    count: i == 0 ? record.skuList.length : 0,
                    remitTime: record.remitTime,
                    itemSku:  record.skuList[i].itemSku,
                    parentSku: record.parentSku
                  }
                  rows.push(data)
                }
              }
              this.detailSkuRemit = rows
              this.showRemitSku = true
            } else {
              let result = await getSkuList({designId: row.designId})
              let rows = []
              for(let record of result.rows){
                for(let i =0; i< record.skuList.length; i++){
                  let data = {
                    designProName: record.designProName,
                    color: record.skuList[i].color,
                    size: record.skuList[i].size,
                    count: i == 0 ? record.skuList.length : 0
                  }
                  rows.push(data)
                }
              }
              this.detailSku = rows
              this.showRemitSku = false
            }
            this.skuVisible = true
            this.endLoading()
          } catch (error) {
            this.endLoading()
          }
        },
        handleDownloadPic(row){
           window.open('/prod-api/server/design/exportPic?designId=' + row.designId)
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
          if (columnIndex === 0) {
            if (row.count != 0) {
              return {
                rowspan: row.count,
                colspan: 1,
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0,
              }
            }
          }
        },
        objectSpanMethodRemit({ row, column, rowIndex, columnIndex }) {
          if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
            if (row.count != 0) {
              return {
                rowspan: row.count,
                colspan: 1,
              }
            } else {
              return {
                rowspan: 0,
                colspan: 0,
              }
            }
          }
        },
          /*编辑设计*/
        async handleShowEdit(row) {
          try {
            //获取设计详情
            let cartData = await getCartMatchInfo(row.designId)
            cartData.data.map(record=>{
              record.productNum = 1
              record.currentSku = record.skuList[0]
              record.attribute = JSON.parse(record.attribute)
              record.currentAttr = {}
              let properVal = record.skuList[0].properVal.split(":")
              record.currentAttr.color = properVal[0]
              record.currentAttr.size = properVal[1]
            })
            this.cartArray = cartData.data
            this.editDesignItem = row
            this.editVisible = true
          } catch (error) {
          }
        },
         handleCloseCellDialog() {
      this.showCellDialog = false
    },
        handleSetParent(row){
           setGroupMain({designId: row.designId ,groupDesignId: row.groupDesignId}).then(re => {
              this.$message({
                  type: 'success',
                  message: '保存成功'
              });
              for(let record of this.cartArray){
                record.groupDesignId = row.designId
              }
              this.getList()
          }).catch(err =>{

          });
        },
        handleSaveDesign(){
          this.detailInfo.remarks = this.editor.getData()
          updateDesign(this.detailInfo).then(re => {
              this.$message({
                  type: 'success',
                  message: '保存成功'
              });
              this.editVisible = false;
          }).catch(err =>{

          });
        },


        /*确认加入购物车*/
        confirmAddCart() {
            if (this.totalCount == 0) {
                this.$message({
                    message: '请至少添加一件!',
                    type: 'warning'
                });
            } else {
                this.cartDialogVisible = false;
                let i = 0;
                this.cartData.forEach(item =>{
                    i++;
                    if (item.count != 0) {
                        let params ={
                            designId:item.designId,//商品id
                            operNo:this.$store.state.user.name,//操作人
                            properName:'颜色:尺码',
                            properVal:item.color +":"+ item.size,
                            num:item.count,//商品数量
                            price:item.price,//商品价格
                            skuId:item.skuId,
                            selfType:'01',
                        }
                        addToShoppingCart(params); //创建购物车
                    }
                    if (this.cartData.length==i)
                        this.$message({message: "加入购物车成功", type:"success", duration: 700});
                });
                this.lastId = "";
                this.totalCount=0;
                this.totalNum=0.00;
                this.totalPrice=0.00;
            }
        },

        /*购物车弹框的计数*/
        getTotalCount(val1,obj){
            let count = 0; let price = 0.00;
            this.cartData.forEach(item =>{
                if(item.count != 0){
                    count += item.count;
                    price += item.price * item.count;
                }
            })
            this.totalCount = count;
            if (count == 0) {
                this.totalNum = 0.00;
            } else {
                this.totalNum = (price/count).toFixed(2);
            }
            this.totalPrice = price.toFixed(2);
        },
        handleChangeUser() {
          this.queryParams.operNos = []
          if (this.isCheckUser) {
            this.userList.map((record) => {
              this.queryParams.operNos.push(record.userName)
            })
          }
        },
        /*通过商品id获取skuList*/
        getSkuList(designId) {
            if (this.lastId != designId) {
                this.lastId = designId;
                this.totalCount=0;
                this.totalNum=0.00;
                this.totalPrice=0.00;
                getDesignSku(designId).then((re) => {
                  let cacheColor = [];
                  let cacheSize = [];
                  let colors = [];
                  let sizes = [];
                    this.cartData = re.data;
                    re.data.forEach(e => {
                      if (cacheColor.indexOf(e.color) < 0) {
                        cacheColor.push(e.color);
                        colors.push(e);
                      }
                      if (cacheSize.indexOf(e.size) < 0) {
                        cacheSize.push(e.size);
                        sizes.push(e)
                      }
                      });
                    this.colors = colors;
                    this.sizes = sizes;

                })
            }
            this.cartDialogVisible = true;
        },

        handleCommand(val){
            if(this.claimCollIds.length==0){
                this.$message('请选择批量操作的数据！');
                return
            }
        },

        /*添加/修改备注*/
        addRemark(index) {
            let remark = this.tableData[index].remark;
            this.$prompt('请输入备注', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: remark,
                // inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
                // inputErrorMessage: '格式不正确'
            }).then(({ value }) => {
                if (remark != value) {
                    this.tableData[index].remark = value;
                    updateDesign(this.tableData[index]).then(re => {
                        this.$message({
                            type: 'success',
                            message: '修改成功! 新备注是: ' + value
                        });
                    }).catch(err =>{

                    });
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });
            });
        },

        //获取店铺数据
        async initPlatData(){
            let platDict;
            await this.getDicts("s_plat_code").then(res => {
                platDict = res.data;
            });
            let platCode = JSON.parse(JSON.stringify(this.$store.state.product.amazon.shopList));
            //获取所有平台代码
            let data = [];
            platDict.forEach(dict => {
                let map ={};
                map.platNo = dict.dictValue;
                map.platName = dict.dictLabel;
                map.shopList = [];
                platCode.forEach(code =>{
                    if(dict.dictValue == code.platNo){
                        map.shopList.push(code)
                    }
                });
                data.push(map);
            });
            this.platList = data.filter(item => {return item.shopList.length > 0});
        },
        platSelect(val,row){
            let shopList = this.platList.filter(plat =>{
                return plat.platNo == val;
            });
            this.shopSelectDialog = true;
            this.shopList = shopList[0].shopList;
            this.currentRow = row;
            this.checkPlat = val;
        },

        submitSelect(){
            let that =this;
            let params = {
                designId:this.currentRow.designId,
                shopIds:this.checkedShops,
                takePlat:this.checkPlat,
                row:this.currentRow
            }
            moveToRelease(params).then(res =>{
                if (res.code == 200) {
                    that.msgSuccess("已成功移入到待发布");
                    that.shopSelectDialog = false;
                }
            }).catch(err =>{});
        },
        handleJumpToBin() {
          if(this.routeName.indexOf('/select/selection/design') > -1){
            this.$router.push({
              path: '/select/selection/recycleBin',
              query: {sDesignId : '01'}
            })
          } else if(this.routeName.indexOf('/carry/proCustom/design') > -1){
            this.$router.push({
              path: '/select/selection/recycleBin',
              query: {sDesignId : '01'}
            })
          } else {
              this.$router.push({
              path: '/select/selection/recycleBin',
              query: {sDesignId : '02'}
            })
          }
        },
        // 删除当前设计
        handleDelItem(row) {
          if(this.claimCollIds.length==0){
            this.$message('请选择批量操作的数据！');
            return
          }
          this.$confirm('是否确认删除', "警告", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
          }).then(async () => {
            for(let record of this.claimCollIds){
                await updateDesign({
                  delFlag: '0',
                  designId: record
                })
            }
            this.getList();
            this.msgSuccess("删除成功");
          }).catch(function() {});
        },
        handleEditDesign(row) {
          window.open('/design/online/designer?designId=' + row.designId)
        },
        handleReDesign(row) {
          window.open('/design/online/designer?pId=' + row.pId)
        },
        getEditor(editor){
            this.editor = editor;
        },
        handleSelectColor(record,color) {
          record.currentAttr.color = color
          this.selectSku(record)
        },
        handleSelectSize(record,size ) {
          record.currentAttr.size = size
          this.selectSku(record)
        },
        selectSku(product) {
          for (let record of product.skuList) {
            console.log( `${product.currentAttr.color}:${product.currentAttr.size}`)
            if (
              record.properVal ===
              `${product.currentAttr.color}:${product.currentAttr.size}`
            ) {
              product.currentSku = record
              product.select = true
              break
            }
          }
        },
    },

}
</script>

<style lang="scss" scoped>
.searchBox {
  margin-top: 1.5%;
  border: 1px solid #d7d7d7;
}

.clain-tab {
  min-width: 1200px;

  .img-small {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    border: 1px solid #ccc;
    padding: 1px;
  }
}

.el-table >>> .cell {
  max-height: 120px;
  line-height: 25px !important;
}

.el-dialog__wrapper >>> .el-dialog {
  width: 20%;
}

.cartType .el-row {
  padding: 3% 0px;
  border-bottom: 1px dashed #88888847;
  text-align: center;
}

.cart-but {
  background: #ff5561;
  width: 95%;
  height: 36px;
  font-size: 18px;
  color: white;
  margin-bottom: 2%;
  margin-left: 2%;
  line-height: 0;
}
.wrapper {
  margin-bottom: 5px;
}
.color-wrapper .color-item {
  height: 40px;
  display: inline-block;
  margin-left: 5px;
  padding: 1px;
  border: 1px solid #e3e3e3;
  cursor: pointer;
}
.product-title {
  font-size: 14px;
  margin: 0 0 8px 0;
}
.size-wrapper .size-item {
  display: inline-block;
  margin-bottom: 5px;
  margin-left: 5px;
  padding: 1px 15px;
  border: 1px solid #f0f0f0;
  background: #f0f0f0;
  cursor: pointer;
}
.price-wrapper {
  color: #4934b2;
}
.price-wrapper .price {
  font-size: 20px;
  font-weight: 800;
}
.sku-attr {
  overflow: hidden;
  margin-top: 15px;
  padding: 0 0 0 8px;
  .sku-name {
    margin: 0 14px 0 0;
    float: left;
    line-height: 39px;
  }
  .sku-detail {
    float: left;
    margin: 5px 0 0 0;
  }
  .sku-detail {
    width: calc(100% - 58px);
    line-height: 39px;
  }
}
.sku-color {
  margin: 0 8px 0 0;
  border: 1px solid #aaaaaa;
  cursor: pointer;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  transition: all 0.5s ease-in-out;
  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
}
.sku-size {
  color: #333;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  text-transform: capitalize;
  display: inline-block;
  margin: 0;
  min-width: 30px;
  overflow: hidden;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 7px;
  transition: all 0.5s ease-in-out;
  padding: 0 3px;
  margin: 0 10px 5px 0;
  border: 2px solid transparent;
  box-shadow: 0 0 0 1px #ddd;
  cursor: pointer;
  box-sizing: border-box;
}
.is-select {
  border: 2px solid #f25551;
  box-shadow: none;
}
.sku-price {
  font-size: 20px;
}
.templateName {
  cursor: pointer;
}
.table-menu {
  width: 100%;
  z-index: 100;
  background: #ffffff;
}

.color-picker-list li,
.color-picker-list-hover li,
.mgg-preview-colors li {
  background-color: #fff;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: #d6d2d2 solid 1px;
  margin-left: 2px;
  padding: 1px;
  float: left;
}

.color-picker-list li.cur,
.mgg-preview-colors li.cur,
.size-picker-list li.cur {
  border: #4934b2 solid 2px;
}

.color-picker-list li a,
.color-picker-list-hover li a,
.mgg-preview-colors li a {
  width: 24px;
  height: 24px;
  display: table;
}

.el-carousel__button {
  width: 7px;
  height: 7px;
  border-radius: 8px;
  background: #8f8f90;
}
.el-carousel__indicator.is-active button {
  background: #4934b2;
}

.preview-area {
  overflow: hidden;
  .carousel {
    width: 600px;
    float: left;
    .el-carousel__item {
      text-align: center;
    }
    ::v-deep .el-carousel__container {
      height: 500px;
    }
    img {
      width: 500px;
      height: 500px;
    }
  }
  .preview-list {
    width: 130px;
    float: left;
    height: 500px;
    margin: 0 0 0 16px;
    overflow-y: auto;
    .preview-list-item {
      border: 1px solid #e5e5e5;
      margin: 0 8px 15px 0;
      box-sizing: border-box;
      width: 111px;
      height: 111px;
      position: relative;
      cursor: pointer;
      .preview-text {
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
        text-align: center;
        width: 100%;
        background: rgba(0, 0, 0, 0.4);
        color: #fff;
        padding: 0.05rem 0;
        font-size: 0.14rem;
        z-index: 10;
        font-size: 14px;
      }
      &:hover .preview-text {
        display: block;
      }
      &.is-active .preview-text {
        display: block;
        background: #4934b2;
      }
    }

    img {
      width: 109px;
      height: 109px;
    }
    .is-active {
      border: 1px solid #4934b2;
    }
  }
  .color-picker {
    overflow: hidden;
    margin: 16px 8px 0 0;
    ul {
      overflow: hidden;
      padding: 0px 0 0 266px;
    }
  }

  .color-picker-list li,
  .color-picker-list-hover li {
    background-color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: #d6d2d2 solid 1px;
    margin-left: 2px;
    padding: 1px;
    float: left;
  }
  .color-picker-list li.cur {
    border: #4934b2 solid 2px;
  }
  .color-picker-list li a,
  .color-picker-list-hover li a {
    width: 24px;
    height: 24px;
    display: table;
  }
}
.form-body {
  .el-col-8 {
    margin: 0px 0 6px 0;
  }
}
.table-body ::v-deep .myCell .el-checkbox {
  display: none;
}

.site {
  position: absolute;
  right: 4px;
  bottom: 10px;
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
  display: block;
  background: rgb(170, 170, 170);
}
</style>
